export default {
  setTimesheets(state, timesheets) {
    state.timesheets = timesheets
  },

  setSummary(state, data) {
    state.summary = data
  },

  setSettings(state, settings) {
    state.settings = { ...state.settings, ...settings }
  },

  add(state, item) {
    state.timesheets.push(item)
  },

  update(state, item) {
    state.timesheets = state.timesheets.map(prev => (prev.id === item.id ? item : prev))
  },

  delete(state, id) {
    state.timesheets = state.timesheets.filter(item => item.id !== id)
  },
}
